export default __webpack_public_path__ + "static/media/img1.b4de5fc1.png";